// import * as storage from './storage'
import {
  KEYS
} from './constants'

/**
 * 存储localStorage
 */
export const setStore = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getStore = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeStore = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}
/**
 * 存储sessionStorage
 */
export const setStoreSession = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取sessionStorage
 */
export const getStoreSession = name => {
  if (!name) return
  return window.sessionStorage.getItem(name)
}

/**
 * 删除sessionStorage
 */
export const removeStoreSession = name => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}

// 用户缓存，避免重复读取缓存
const CACHED = {}

// 设置缓存
const setCache = (key, val) => {
  CACHED[key] = val

  return storage.setItem(key, val)
}

// 获取缓存
const getCache = key => {
  if (CACHED[key]) {
    return CACHED[key]
  }

  CACHED[key] = storage.getItemSync(key)

  return CACHED[key]
}

// 移除缓存
const removeCache = key => {
  delete CACHED[key]

  return storage.removeItem(key)
}

/**
 * 生成全局唯一标识
 */
const generateUUID = () => {
  var d = new Date().getTime()
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}
let deviceId = generateUUID()

// 唯一标识 是否生成
let deviceIdIs = () => {
  if (!getStore('deviceId')) {
    setStore('deviceId', deviceId)
  } else {
    getStore('deviceId')
  }
}

/**
 * 获取缓存中的token（同步）
 * @return {string} token
 */
export const getToken = () => getCache(KEYS.TOKEN_KEY)

/**
 * 将token保存到缓存中(同步)
 * @param  {string} token
 * @return {undefined}
 */
export const saveToken = val => setCache(KEYS.TOKEN_KEY, val)

/**
 * @date Date类型对象
 * @fmt 格式化字符串  月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 *                   年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * 例子：
 * dateformat(new Date(), "yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
 * dateformat(new Date(), "yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
 */
export const dateformat = (date, fmt) => {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length)) }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

/**
 * 获取一周内的时间
 * @containToday: Boolean，默认值true，表示返回日期包含今天，否则返回日期截止到昨天
 * 例子：比如今天是'2018-07-08'
 * getWeeks();       // return ['2018-07-02', '2018-07-08']
 * getWeeks(false);  // return ['2018-07-01', '2018-07-07']
 */
export const getWeeks = (containToday) => {
  let weeks = []
  let now = ''
  if (containToday === false) {
    now = new Date(getDateStr(-1))
  } else {
    now = new Date()
  }
  let lastweek = new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000)
  weeks.push(dateformat(lastweek, 'yyyy-MM-dd'), dateformat(now, 'yyyy-MM-dd'))
  return weeks
}

/**
 * 获取一月内的时间
 * @containToday: Boolean，默认值true，表示返回日期包含今天，否则返回日期截止到昨天
 * 例子：比如今天是'2018-07-08'
 * getMonths();  // return ['2018-06-08', '2018-07-08']
 * getMonths(false);  // return ['2018-06-07', '2018-07-07']
 */
export const getMonths = (containToday) => {
  let months = []
  let now = ''
  if (containToday === false) {
    now = new Date(getDateStr(-1))
  } else {
    now = new Date()
  }
  months.push(dateformat(now, 'yyyy-MM-dd'))
  let lastmonth = new Date(now.setMonth(now.getMonth() - 1))
  months.push(dateformat(lastmonth, 'yyyy-MM-dd'))
  return months.reverse()
}

/**
 * 获取一年内的时间
 * 返回值数组 arr[0]：一年前的那天，arr[1]：今天
 * 例子：
 * getWeeks();  // return ['2017-07-08', '2018-07-08']
 */
export const getYears = () => {
  let years = []
  let now = new Date()
  years.push(dateformat(now, 'yyyy-MM-dd'))
  let lastmonth = new Date(now.setFullYear(now.getFullYear() - 1))
  years.push(dateformat(lastmonth, 'yyyy-MM-dd'))
  return years.reverse()
}

/** 获取当前URL里的查询参数
 *
 * @param url
 * @returns {{}|*}
 */
export const getUrlParams = url => {
  url = url || window.location.href
  let queryArray = url.split(/[?&#]/).slice(1)
  let i
  let args = {}
  for (i = 0; i < queryArray.length; i++) {
    var match = queryArray[i].match(/([^=]+)=([^=]+)/)
    if (match !== null) {
      args[match[1]] = decodeURIComponent(match[2])
    }
  }
  return args
}

export const getdeviceId = () => deviceIdIs()

/**
 * 获取相对于今天的日期
 * dayCount = -1 表示昨天，dayCount = 0 表示今天，dayCount = 1 表示明天
 * 例子：
 * getDateStr(-1);  // return '2018-11-18'
 */
export const getDateStr = dayCount => {
  if (dayCount == null) {
    dayCount = 0
  }
  let date = new Date()
  date.setDate(date.getDate() + dayCount)
  let y = date.getFullYear()
  let m = date.getMonth() + 1
  let d = date.getDate()
  return y + '-' + m + '-' + d
}

/* ／获取url参数 */
export const getQueryString = (key) => {
  // 获取参数
  var url = window.location.search
  // 正则筛选地址栏
  var reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)')
  // 匹配目标参数
  var result = url.substr(1).match(reg)
  // 返回参数值
  return result ? result[2] : null
}



// WEBPACK FOOTER //
// ./src/publicResource/utils/utils.js